export default [
    {
        key: "pravaya_petlya",
        allArray: "allWardrobeDoors",
        activeArray: "activeWardrobeDoors",
        position: "bottom",
        extra: (el) => {
            el.userData.doorSide = "right";
        },
    },
    {
        key: "levaya_petlya",
        allArray: "allWardrobeDoors",
        activeArray: "activeWardrobeDoors",
        position: "bottom",
        extra: (el) => {
            el.userData.doorSide = "left";
        },
    },
];
